import React, { useState } from "react";
import { IoCloseSharp } from "react-icons/io5";

const ModalCloseButton = ({ onClose, size = 20, color = "#6b7280", hoverColor = "#ef4444" }) => {
  const [hover, setHover] = useState(false);

  return (
    <button
      type="button"
      title="Close"
      onClick={(e) => onClose(e)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: 0,
      }}
    >
      <IoCloseSharp
        size={size}
        style={{
          transition: "transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), color 0.25s ease",
          transform: hover ? "rotate(90deg) scale(1.15)" : "rotate(0deg) scale(1)",
          color: hover ? hoverColor : color,
        }}
      />
    </button>
  );
};

export default ModalCloseButton;